define('bizzabo/models/ServicePlan',[
    'underscore',
    'bizzabo/bzapi',
    'bizzabo/utils',
    'backbone',
    'bizzabo/models/SyncedModel',
    'bizzabo/models/Global'

], function(
    _,
    BZAPI,
    UTILS,
    Backbone,
    SyncedModel,
    Global
    ) {

    var ServicePlan = SyncedModel.extend({

        shouldFetch : true,

        sync : function(method, model, options) {
            if (method === 'read') {
                var id = null;
                var func = null;
                if (model.id) {
                    func = 'getServicePlan';
                    id = model.id;
                } else if (model.eventId === 'new') {
                    func = 'getFreeServicePlan';
                } else if (model.eventId) {
                    func = 'getServicePlanByEventID';
                    id = model.eventId;
                }
                func && BZAPI[func](id, function(data) {
                    model.setFlagsAfterSync();
                    options.success && options.success(data, options);
                }, options.error);
            } else if (method === 'update') {
                BZAPI.updateServicePlan(model.id, model.toJSON(), function(data) {
                    options.success && options.success(data, options);
                }, options.error);
            }
        },

        parse: function(response) {
            response.total = UTILS.ensureArray(response.total);
            var features = _.object(_.pluck(response.total, 'feature'), _.pluck(response.total, 'count'));
            return _.extend(response, features);
        },

        hasFeature: function(feature) {
            var allBundles = this.get('total');
            return _.findWhere(allBundles, {feature: feature});
        },

        upgradeUrlQuery: function(event) {
            var query = ['bundleId=23'];
            if (this.id) {
                query.push('packageId=' + this.id);
            } else if (this.eventId !== 'new') {
                query.push('eventId=' + this.eventId);
            }

            var activeEvent = event || Global.modelPool.getActiveEvent();
            var accountId = activeEvent ? activeEvent.get('account-id') : undefined;
            query.push('accountId=' + accountId);
            return query.join('&');
        }
    });

    return ServicePlan;

});
